export default {"src":"/_next/static/media/XP.b2bb3a06.svg","height":18,"width":18};